module.exports = __webpack_public_path__ + "static/media/Sepultura.f8dedd1c.svg";